const safeJSONParse = (str: unknown, respondWithOnFail: unknown = false): unknown => {
  if (typeof str !== 'string') {
    return respondWithOnFail;
  }

  try {
    return JSON.parse(str);
  } catch (e) {
    console.error('JSON parsing failed:', e);
    return respondWithOnFail;
  }
};

export default safeJSONParse;
